<div class="splash-bg">
  <div class="circle circle-1"></div>
  <div class="circle circle-2" [ngClass]="{active: circle2On}"></div>
</div>
<table>
  <tbody>
    <tr>
      <td style="font-weight: bold">Firm Name</td>
      <td style="font-weight: bold; color: crimson">:{{ firmname }}</td>
    </tr>
  </tbody>
</table>